/**
 * Benitez Homepage - Tab switching for Comercial & Residencial sections
 */
(function() {
  'use strict';

  function initTabs() {
    document.querySelectorAll('.bnz-tab-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = this.closest('.bnz-tabs-group');
        if (!group) return;

        // Remove active from all buttons in this group
        group.querySelectorAll('.bnz-tab-btn').forEach(function(b) {
          b.classList.remove('active');
        });
        this.classList.add('active');

        // Show corresponding panel
        var target = this.getAttribute('data-tab');
        var container = group.closest('.bnz-split-section') || group.parentElement;
        container.querySelectorAll('.bnz-tab-panel').forEach(function(panel) {
          panel.classList.remove('active');
        });
        var targetPanel = container.querySelector('[data-panel="' + target + '"]');
        if (targetPanel) {
          targetPanel.classList.add('active');
        }
      });
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
  } else {
    initTabs();
  }
})();
